import { createGlobalStyle } from "styled-components";

import FuturaEOT from "./fonts/futura/3219A3_0_0.eot";
import FuturaWOFF2 from "./fonts/futura/3219A3_0_0.woff2";
import FuturaWOFF from "./fonts/futura/3219A3_0_0.woff";
import FuturaTTF from "./fonts/futura/3219A3_0_0.ttf";
import FuturaDemiEOT from "./fonts/futura/3219A3_5_0.eot";
import FuturaDemiWOFF2 from "./fonts/futura/3219A3_5_0.woff2";
import FuturaDemiWOFF from "./fonts/futura/3219A3_5_0.woff";
import FuturaDemiTTF from "./fonts/futura/3219A3_5_0.ttf";

import FuturaMediumEOT from "./fonts/futura/3219A3_3_0.eot";
import FuturaMediumWOFF2 from "./fonts/futura/3219A3_3_0.woff2";
import FuturaMediumWOFF from "./fonts/futura/3219A3_3_0.woff";
import FuturaMediumTTF from "./fonts/futura/3219A3_3_0.ttf";

import OggBoldEOT from "./fonts/ogg/Ogg-Bold.eot";
import OggBoldWOFF2 from "./fonts/ogg/Ogg-Bold.woff2";
import OggBoldWOFF from "./fonts/ogg/Ogg-Bold.woff";
import OggBoldTTF from "./fonts/ogg/Ogg-Bold.ttf";
import OggRegularEOT from "./fonts/ogg/Ogg-Regular.eot";
import OggRegularWOFF2 from "./fonts/ogg/Ogg-Regular.woff2";
import OggRegularWOFF from "./fonts/ogg/Ogg-Regular.woff";
import OggRegularTTF from "./fonts/ogg/Ogg-Regular.ttf";

const Fonts = createGlobalStyle`
  @font-face {
    font-family: 'FuturaPT-Book';
    src: local('FuturaPT-Book'), local('FuturaPT-Book'), url(${FuturaEOT}) format('eot'),
         url(${FuturaWOFF2}) format('woff2'), url(${FuturaWOFF}) format('woff'), url(${FuturaTTF}) format('truetype');
    font-display: swap;
  }
  @font-face {
    font-family: 'FuturaPT-Demi';
    src: local('FuturaPT-Demi'), local('FuturaPT-Demi'), url(${FuturaDemiEOT}) format('eot'),
         url(${FuturaDemiWOFF2}) format('woff2'), url(${FuturaDemiWOFF}) format('woff'), url(${FuturaDemiTTF}) format('truetype');
    font-display: swap;
  }
  @font-face {
    font-family: 'Ogg-Bold';
    src: local('Ogg-Boldk'), local('Ogg-Bold'), url(${OggBoldEOT}) format('eot'),
         url(${OggBoldWOFF2}) format('woff2'), url(${OggBoldWOFF}) format('woff'), url(${OggBoldTTF}) format('truetype');
    font-display: swap;
  }
  @font-face {
    font-family: 'Ogg-Regular';
    src: local('Ogg-Regular'), local('Ogg-Regular'), url(${OggRegularEOT}) format('eot'),
         url(${OggRegularWOFF2}) format('woff2'), url(${OggRegularWOFF}) format('woff'), url(${OggRegularTTF}) format('truetype');
    font-display: swap;
  }
  @font-face {
    font-family: 'FuturaPT-Medium';
    src: local('FuturaPT-Medium'), local('FuturaPT-Medium'), url(${FuturaMediumEOT}) format('eot'),
         url(${FuturaMediumWOFF2}) format('woff2'), url(${FuturaMediumWOFF}) format('woff'), url(${FuturaMediumTTF}) format('truetype');
    font-display: swap;
  }
`;

export default Fonts;
